import React from 'react'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import TabContainer from 'components/elements/TabButtons'
import RecentChanges from 'components/deckPage/deckHistory/recentChanges'
import AddRemoveCards from 'components/deckPage/deckHistory/addRemoveCards'
import DeckVersions from 'components/deckPage/deckHistory/deckVersions'

import styles from './historyModal.module.scss'

const HistoryModal = () => {
  const addRemovedCards = useAppSelector(state => state.active.modals.addRemovedCards)
  const recentChanges = useAppSelector(state => state.active.modals.recentChanges)
  const snapshots = useAppSelector(state => state.active.modals.snapshots)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const open = addRemovedCards || recentChanges || snapshots

  return (
    <GlobalOverlayStack
      open={open}
      className={styles.container}
      onClose={() => setActiveState({ modals: {}, modalActive: false })}>
      <TabContainer
        className={styles.tabs}
        optionsClassName={styles.tabButton}
        options={[
          {
            icon: 'clock',
            label: 'Changelog',
            onClick: () => setActiveState({ modals: { recentChanges: true } }),
            selected: recentChanges,
          },
          {
            icon: 'exchange',
            label: 'Added/Removed',
            onClick: () => setActiveState({ modals: { addRemovedCards: true } }),
            selected: addRemovedCards,
          },
          {
            icon: 'code branch',
            label: 'Snapshots',
            onClick: () => setActiveState({ modals: { snapshots: true } }),
            selected: snapshots,
          },
        ]}
      />

      {recentChanges && <RecentChanges />}
      {addRemovedCards && <AddRemoveCards />}
      {snapshots && <DeckVersions />}
    </GlobalOverlayStack>
  )
}

export default HistoryModal
